
export default {
  name: "the-change-password",
  components: {

  },
  props: {
    description: {},
    title: {},
    requireValidation: {
      default: true,
      type: Boolean,
      required: false
    },
    error: {
      required: false,
      default: '',
      type: String
    },
    layout: {
      required: false,
      default: 'chain',
      type: String
    }
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      oldPasswordVisible: false,
      newPasswordVisible: false,

      validated: false,
      rules: {
        required: value => !!value || 'Dette feltet er obligatorisk.',
        password: value => {
          const pattern = /^(?=.*\d)(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/
          return pattern.test(value) || 'Passord må inneholde minimum 8 tegn, minst ett tall og en stor bokstav.'
        },
      },
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.$emit("setOldPassword", this.oldPassword);
      this.$emit("setNewPassword", this.newPassword);
      if (this.$refs.newPasswordInput.validate() && this.$refs.oldPasswordInput.validate()) {
          this.$emit("verify");
      }
    },
    onOldInput(value) {
        this.oldPassword = value
        this.$emit("setOldPassword", value);
    },
    onNewInput(value) {
       this.newPassword = value
       this.$emit("setNewPassword", value);
    },
    validate() {
      return this.validated
    },
    clearStates() {
        this.oldPassword = ''
        this.newPassword = ''
        this.oldPasswordVisible = false
        this.newPasswordVisible = false
        this.validated = false
    }
  },
  beforeDestroy() {
    this.clearStates()
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.oldPasswordInput.$refs.input.focus()
      })
    })
  },
}
